import Helpers from 'helpers/util';
import $ from 'jquery';

const representativeContactFormObject = (action, label) => {
	return {
		'custom.event.representative_action': action,
		'custom.event.representative_label': label,
	};
};

class GAEvents {
	constructor() {
		Helpers.pubsub.subscribe('GAEvent', (name, args) => {
			const gaType = args.gaType ? args.gaType : 'default';

			const gtmEvent = (type) => {
				const obj = {
					sendemail: () => {
						const eventName = 'custom.event.representative_submit'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							...representativeContactFormObject(
								'send email',
								'email representative'
							),
						});
						Helpers.GTM.push(eventObject);
					},
					requestcall: () => {
						const eventName = 'custom.event.representative_submit'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							...representativeContactFormObject(
								'request call',
								'request call from representative'
							),
						});
						Helpers.GTM.push(eventObject);
					},
					requestvisit: () => {
						const eventName = 'custom.event.representative_submit'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							...representativeContactFormObject(
								'request visit',
								'request visit from representative'
							),
						});
						Helpers.GTM.push(eventObject);
					},
					'external-elearning': () => {
						const eventName = 'custom.event.outboundExternal_click'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							'custom.event.outbound_link': window.location.href,
						});
						Helpers.GTM.push(eventObject);
					},
					pdfarticle: () => {
						const eventName = 'custom.event.printPDF_click'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							'custom.event.printPDF_link':
								args.event.currentTarget.getAttribute('href'),
						});
						Helpers.GTM.push(eventObject);
					},
					savearticle: () => {
						const eventName = 'custom.event.saveArticle_click'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName);
						Helpers.GTM.push(eventObject);
					},
					// new
					click_navigation: () => {
						const getSectionInfo = (element) => {
							if (element.closest('.nav-desktop-bottom') !== null) {
								return {
									section: 'header',
									sub_section: 'nav primary main link',
								};
							} else if (element.closest('.nav-desktop-top') !== null) {
								return {
									section: 'header',
									sub_section: 'nav primary account link',
								};
							} else if (element.closest('.quick-links') !== null) {
								return {
									section: 'footer',
									sub_section: 'footer quick link',
								};
							} else if (element.closest('#product_info_download') !== null) {
								return {
									section: 'footer',
									sub_section: 'footer product info download link',
								};
							} else if (
								element.closest('.sales-rep-links-container') !== null
							) {
								return {
									section: 'footer',
									sub_section: 'footer primary sales rep link',
								};
							}
						};
						const eventName = 'navigation'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							section: getSectionInfo(args.event.currentTarget).section,
							sub_section: getSectionInfo(args.event.currentTarget).sub_section,
							element: args.event.currentTarget.textContent,
							'Interaction type': 'navigation',
						});
						Helpers.GTM.push(eventObject);
					},
					//custom.event.saveArticle_click
					leavesite: () => {
						const eventName = 'custom.event.outbound_click'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							'custom.event.outbound_link':
								args.event.target.getAttribute('href'),
						});
						Helpers.GTM.push(eventObject);
					},
					registration: () => {
						const eventName = 'custom.event.registration_submit'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							'custom.event.registration_label': 'homepage registration',
						});
						Helpers.GTM.push(eventObject);
					},
					onboarding_begin: () => {
						const eventName = 'custom.event.registration_progress';
						const event = Helpers.GTM.create(eventName, {
							'custom.event.registration_progress_label':
								'homepage clicked register',
						});
						Helpers.GTM.push(event);
					},
					onboarding_step_1: () => {
						const eventName = 'custom.event.registration_progress';
						const event = Helpers.GTM.create(eventName, {
							'custom.event.registration_progress_label': 'onboarding step 1',
						});
						Helpers.GTM.push(event);
					},
					onboarding_step_2: () => {
						const eventName = 'custom.event.registration_progress';
						const event = Helpers.GTM.create(eventName, {
							'custom.event.registration_progress_label': 'onboarding step 2',
						});
						Helpers.GTM.push(event);
					},
					onboarding_step_3: () => {
						const eventName = 'custom.event.registration_progress';
						const event = Helpers.GTM.create(eventName, {
							'custom.event.registration_progress_label': 'onboarding step 3',
						});
						Helpers.GTM.push(event);
					},
					onboarding_submit: () => {
						const eventName = 'custom.event.registration_progress';
						const event = Helpers.GTM.create(eventName, {
							'custom.event.registration_progress_label':
								'onboarding form completion',
						});
						Helpers.GTM.push(event);
					},
					onboarding: () => {
						const eventName = 'custom.event.registration_submit'; // Trigger (inside GTM)
						const eventObject = Helpers.GTM.create(eventName, {
							'custom.event.registration_label': 'onboarding form completion',
						});
						Helpers.GTM.push(eventObject);
					},
					cc_breach_form: () => {
						const eventName = 'custom.event.breach_form_submit';
						const eventObject = Helpers.GTM.create(eventName, {});
						Helpers.GTM.push(eventObject);
					},
					default: () => {
						console.error('Error type not found');
					},
				};
				return (obj[type] || obj['default'])();
			};

			gtmEvent(gaType);
		});

		// nav bottom links
		$(
			'.nav-desktop-links a, .nav-desktop-top a, .quick-links a, .sales-rep-links-container a'
		).on('click', (evt) => {
			Helpers.pubsub.publish('GAEvent', {
				event: evt,
				gaType: 'click_navigation',
			});
		});

		$('#product_info_download').on('change', (evt) => {
			Helpers.pubsub.publish('GAEvent', {
				event: evt,
				gaType: 'click_navigation',
			});
		});

		$('.article-tools a').on('click', (evt) => {
			const $element = $(evt.currentTarget);
			if ($element.find('.icon-favourite').length) {
				Helpers.pubsub.publish('GAEvent', {
					event: evt,
					gaType: 'savearticle',
				});
			} else if ($element.find('.icon-print').length) {
				Helpers.pubsub.publish('GAEvent', {
					event: evt,
					gaType: 'pdfarticle',
				});
			}
		});

		// print icon
		$('.icon-print').click(function () {
			window.ga('send', 'event', {
				eventCategory: 'PDF Download',
				eventAction: `Download ${$(this).attr('href')}`,
				eventLabel: window.location.pathname,
			});
		});
	}
}

const _init = () => {
	new GAEvents();
};

_init();
